export default __webpack_public_path__ + "static/media/groundtruth_logo.f6266ba2.svg";